/*
 * EGO Tactical — theme-hosted product options fallback.
 *
 * Infinite Options (options.shopapps.site) is the primary options UI. Some
 * corporate/school firewalls block that host, which leaves the PDP with no way
 * to pick a phone model and no way to buy. This file renders an equivalent
 * 1-2-3-4 picker that only appears when Infinite Options fails to load.
 *
 * Option names, prices and upgrade variant IDs below are mirrored from the live
 * Infinite Options config:
 *   https://options.shopapps.site/v2/egotacticialusa.myshopify.com/generate_option/<product_id>
 * Regenerate with _research/gen_data.py in the ego-compatibility-badge repo if
 * the merchant edits options in the SC Product Options admin.
 */
(function () {
  'use strict';

  if (window.__egoThemeOptionsInit) return;
  window.__egoThemeOptionsInit = true;

  /* ------------------------------------------------------------------ data */

  var MODELS = {
    Apple: [
      'iPhone 18 ProMax (New)', 'iPhone 18 Pro (New)', 'iPhone 17 ProMax', 'iPhone 17 Air',
      'iPhone 17 Pro', 'iPhone 17', 'iPhone 16e /17e', 'iPhone 16 ProMax', 'iPhone 16 Plus',
      'iPhone 16 Pro', 'iPhone 16', 'iPhone 15 ProMax', 'iPhone 15 Plus', 'iPhone 15 Pro',
      'iPhone 15', 'iPhone 14 ProMax', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14',
      'iPhone 13 ProMax', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 Mini', 'iPhone 12 ProMax',
      'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 Mini', 'iPhone 11 ProMax', 'iPhone 11 Pro',
      'iPhone 11', 'iPhone XsMax', 'iPhone Xr', 'iPhone X, Xs', 'iPhone 8', 'iPhone 8+',
      'iPhone 7', 'iPhone 7+', 'iPhone 6/6s', 'iPhone 6+/6s+',
      'iPhone SE2/SE3 (2020/2022 Version)'
    ],
    Samsung: [
      'Galaxy S26 Ultra', 'Galaxy S26 Plus', 'Galaxy S26', 'Galaxy S25 Ultra', 'Galaxy S25 Plus',
      'Galaxy S25 FE', 'Galaxy S25', 'Galaxy S24 Ultra', 'Galaxy S24 Plus', 'Galaxy S24 FE',
      'Galaxy S24', 'Galaxy S23 Ultra', 'Galaxy S23 Plus', 'Galaxy S23 FE', 'Galaxy S23',
      'Galaxy S22 Ultra', 'Galaxy S22 Plus', 'Galaxy S22', 'Galaxy S21 Ultra', 'Galaxy S21 Plus',
      'Galaxy S21 FE', 'Galaxy S21', 'Galaxy S20 Ultra', 'Galaxy S20 Plus', 'Galaxy S20 FE',
      'Galaxy S20', 'Galaxy S10 Plus', 'Galaxy S10e', 'Galaxy S10', 'Galaxy S9 Plus', 'Galaxy S9',
      'Galaxy S8', 'Galaxy S7', 'Galaxy S6', 'Galaxy S5', 'Galaxy A03 4g', 'Galaxy A04s 4g',
      'Galaxy A05 4g', 'Galaxy A06', 'Galaxy A11 4g', 'Galaxy A12 4g', 'Galaxy A13 4g & 5g',
      'Galaxy A14 5g', 'Galaxy A15 4g & 5g', 'Galaxy A16 5g', 'Galaxy A17 5g', 'Galaxy A21 4g',
      'Galaxy A22 5g', 'Galaxy A23 4g/5g', 'Galaxy A24 5g', 'Galaxy A25 4g', 'Galaxy A25 5g',
      'Galaxy A26 5g', 'Galaxy A32 5g', 'Galaxy A33 5g', 'Galaxy A34 5g', 'Galaxy A35 5g',
      'Galaxy A36 5g', 'Galaxy A37 5g', 'Galaxy A42 5g', 'Galaxy A51 4g', 'Galaxy A51 5g',
      'Galaxy A52 4g & 5g', 'Galaxy A53 5g', 'Galaxy A54 5g', 'Galaxy A55 5g', 'Galaxy A56 5g',
      'Galaxy A57 5g', 'Galaxy A71 5g', 'Galaxy A72 4g & 5g', 'Galaxy A73 5g', 'Galaxy F12 4g',
      'Galaxy M12 4g', 'Galaxy M42 5g', 'Galaxy M54 5g', 'Galaxy Note 8', 'Galaxy Note 9',
      'Galaxy Note 10', 'Galaxy Note 10 Plus', 'Galaxy Note 20 5g', 'Galaxy Note 20 Ultra 5g',
      'Galaxy X Cover6 Pro/X Cover Pro 2', 'Galaxy X Cover 7', 'Galaxy Z Flip 3 5g',
      'Galaxy Z Flip 4 5g', 'Galaxy Z Flip 5 5g', 'Galaxy Z Flip 7 5g', 'Galaxy Z Flip 8 5g',
      'Galaxy Z Fold 3 5g', 'Galaxy Z Fold 4 5g', 'Galaxy Z Fold 5 5g', 'Galaxy Z Fold 6 5g',
      'Galaxy Z Fold 7 5g', 'Galaxy Z Fold 8 5g', 'Galaxy Z Fold 8 Ultra 5g'
    ],
    Google: [
      'Pixel 11 Pro XL (6.8" Screen)', 'Pixel 11 & 11 Pro (6.3" Screen)',
      'Pixel 10 Pro XL (6.8" Screen)', 'Pixel 10 & 10 Pro (6.3" Screen)', 'Pixel 10 Pro Fold',
      'Pixel 10a', 'Pixel 9 Pro XL (6.8" Screen)', 'Pixel 9a (6.3" Screen)',
      'Pixel 9 & 9 Pro (6.3" Screen)', 'Pixel 8a 5g', 'Pixel 8 Pro 5g', 'Pixel 8 5g',
      'Pixel 7 Pro 5g', 'Pixel 7a 5g', 'Pixel 7 5g', 'Pixel 6 Pro 5g', 'Pixel 6a 5g',
      'Pixel 6 5g', 'Pixel 5a 5g', 'Pixel 5 5g', 'Pixel 4 XL', 'Pixel 4a 5g', 'Pixel 4a 4g',
      'Pixel 4 4g', 'Pixel 3 XL 4g'
    ],
    Motorola: [
      'Edge (2022)', 'Edge 40 (2024)', 'Edge Plus (2022)', 'Edge Plus (2023)', 'Edge S (2021)',
      'G 5g Plus (2021)', 'G 5g (2022) G6', 'G6 Plus', 'G100', 'G Fast', 'G Play (2021)',
      'G Play (2022)', 'G Play (2023)', 'G Play (2024)', 'G Power (2021)', 'G Power (2022)',
      'G Power 5G (2023)', 'G Pure (2021)', 'G Stylus 4g (2021)', 'G Stylus 4g (2022)',
      'G Stylus 5g (2022)', 'G Stylus 5g (2023)', 'One 5g (2021)', 'One 5g Ace (2021)',
      'One 5g UW (2021)', 'One 5g UW Ace (2021)', 'ThinkPhone (2023)'
    ]
  };

  // Case-brand choices. price is in cents; variant is the upgrade-fee variant on
  // product 3887533260903 "Name-Brand Case Upgrade Fees".
  var CASE_SETS = {
    cs1866500: [['Magpul Field Case', 0, 39634433572967], ['Magpul Bump Case', 0, 39634433441895]],
    cs1866525: [['Rugged Shield Case', 0, 39634433605735], ['Magpul Field Case', 0, 39634433572967], ['Magpul Bump Case', 0, 39634433441895], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1866948: [['Magpul Field Case', 0, 39634433572967], ['Pelican Case', 0, 29267855048807], ['Urban Armor Gear', 2000, 39634433507431], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1866953: [['Rugged Shield Case', 0, 39634433605735], ['Magpul Bump Case', 0, 39634433441895], ['Pelican Case', 1000, 39634433310823], ['Urban Armor Gear', 3000, 39634433540199], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1705738: [['Rugged Shield Case', 0, 39634433605735]],
    cs1866528: [['Rugged Shield Case', 0, 39634433605735], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1866520: [['Rugged Shield Case', 0, 39634433605735], ['Urban Armor Gear', 2000, 39634433507431], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1866541: [['Rugged Shield Case', 0, 39634433605735], ['Urban Armor Gear', 1000, 39634433343591]],
    cs1866538: [['Rugged Shield Case', 0, 39634433605735], ['Urban Armor Gear Plasma', 2000, 39634433507431], ['Urban Armor Gear Pathfinder+', 3000, 39634433540199], ['Otterbox Symmetry', 3000, 39634433409127], ['Otterbox Symmetry Plus (MagSafe)', 4000, 39634433474663]],
    cs1866545: [['Pelican Adventurer Case', 0, 29267855048807], ['Urban Armor Gear Plasma', 1000, 39634433343591], ['Otterbox Symmetry', 3000, 39634433409127]],
    cs1898539: [['Urban Armor Gear', 1000, 39634433343591]],
    cs1866957: [['UAG Civilian or Mouve Case', 3000, 39634433540199]],
    cs2032826: [['Rugged Shield Case', 0, 39634433605735], ['UAG Scout Case', 1000, 44495047459124], ['Otterbox Symmetry Case', 3000, 39634433409127]],
    cs1898672: [['Rugged Shield Case', 0, 39634433605735], ['Pelican Case', 1000, 39634433310823], ['Urban Armor Gear', 2000, 39634433507431], ['Otterbox Symmetry Case', 3000, 39634433409127]],
    cs1898690: [['Rugged Shield Case', 0, 39634433605735]],
    cs1998095: [['UAG PLYO PRO w/MagSafe', 3000, 39634433540199]],
    cs2210671: [['Rugged Shield TPU Case', 0, 39634433605735], ['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2273865: [['Rugged Shield TPU Case', 0, 39634433605735], ['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2302322: [['Rugged Shield TPU Case', 0, 39634433605735], ['Urban Armor Gear Civilian LT Case (w/MagSafe)', 1000, 44495047459124], ['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2317490: [['Rugged Shield Case (w/MagSafe)', 0, 39634433605735], ['Urban Armor Gear Civilian LT Case (w/MagSafe)', 1000, 44495047459124], ['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2318410: [['Rugged Shield', 0, 39634433605735], ['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199]],
    cs2318417: [['Rugged Shield (w/MagSafe)', 0, 39634433605735], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2323019: [['UAG Mouve', 3000, 39634433540199]],
    cs2364183: [['Urban Armor Gear Pathfinder Case (w/MagSafe)', 3000, 39634433540199], ['Otterbox Symmetry Plus Case (w/MagSafe)', 4000, 39634433474663]],
    cs2367879: [['UAG Scout Case', 1000, 44495047459124]]
  };

  // "Brand|Model" -> case set key. Mirrors the Infinite Options SHOW conditions.
  var CASE_BY_MODEL = {
    'Samsung|Galaxy S5': 'cs1866500', 'Apple|iPhone 6+/6s+': 'cs1866525', 'Apple|iPhone 7+': 'cs1866525',
    'Apple|iPhone 8+': 'cs1866525', 'Samsung|Galaxy S8': 'cs1866948', 'Samsung|Galaxy S9 Plus': 'cs1866953',
    'Apple|iPhone 6/6s': 'cs1705738', 'Apple|iPhone 7': 'cs1705738', 'Apple|iPhone 8': 'cs1705738',
    'Google|Pixel 3 XL 4g': 'cs1705738', 'Google|Pixel 5a 5g': 'cs1705738', 'Google|Pixel 6a 5g': 'cs1705738',
    'Google|Pixel 7a 5g': 'cs1705738', 'Google|Pixel 6 Pro 5g': 'cs1705738',
    'Motorola|Edge Plus (2022)': 'cs1705738', 'Motorola|Edge S (2021)': 'cs1705738',
    'Motorola|G 5g Plus (2021)': 'cs1705738', 'Motorola|G 5g (2022) G6': 'cs1705738',
    'Motorola|G6 Plus': 'cs1705738', 'Motorola|G100': 'cs1705738', 'Motorola|G Fast': 'cs1705738',
    'Motorola|G Play (2021)': 'cs1705738', 'Motorola|G Play (2022)': 'cs1705738',
    'Motorola|G Pure (2021)': 'cs1705738', 'Motorola|G Stylus 4g (2021)': 'cs1705738',
    'Motorola|G Stylus 4g (2022)': 'cs1705738', 'Motorola|G Stylus 5g (2022)': 'cs1705738',
    'Motorola|One 5g (2021)': 'cs1705738', 'Motorola|One 5g Ace (2021)': 'cs1705738',
    'Motorola|One 5g UW (2021)': 'cs1705738', 'Motorola|One 5g UW Ace (2021)': 'cs1705738',
    'Motorola|G Play (2023)': 'cs1705738', 'Motorola|Edge Plus (2023)': 'cs1705738',
    'Motorola|G Power 5G (2023)': 'cs1705738', 'Motorola|G Stylus 5g (2023)': 'cs1705738',
    'Motorola|Edge 40 (2024)': 'cs1705738', 'Motorola|G Play (2024)': 'cs1705738',
    'Motorola|ThinkPhone (2023)': 'cs1705738', 'Apple|iPhone 13 Mini': 'cs1705738',
    'Apple|iPhone 12 Mini': 'cs1705738', 'Samsung|Galaxy A11 4g': 'cs1705738',
    'Samsung|Galaxy A13 4g & 5g': 'cs1705738', 'Samsung|Galaxy A21 4g': 'cs1705738',
    'Samsung|Galaxy A22 5g': 'cs1705738', 'Samsung|Galaxy A23 4g/5g': 'cs1705738',
    'Samsung|Galaxy A33 5g': 'cs1705738', 'Samsung|Galaxy A71 5g': 'cs1705738',
    'Samsung|Galaxy A72 4g & 5g': 'cs1705738', 'Samsung|Galaxy A73 5g': 'cs1705738',
    'Samsung|Galaxy F12 4g': 'cs1705738', 'Samsung|Galaxy M12 4g': 'cs1705738',
    'Samsung|Galaxy M42 5g': 'cs1705738', 'Samsung|Galaxy A03 4g': 'cs1705738',
    'Samsung|Galaxy A04s 4g': 'cs1705738', 'Samsung|Galaxy A12 4g': 'cs1705738',
    'Samsung|Galaxy X Cover6 Pro/X Cover Pro 2': 'cs1705738', 'Samsung|Galaxy A14 5g': 'cs1705738',
    'Samsung|Galaxy A24 5g': 'cs1705738', 'Samsung|Galaxy A34 5g': 'cs1705738',
    'Samsung|Galaxy A54 5g': 'cs1705738', 'Samsung|Galaxy A05 4g': 'cs1705738',
    'Samsung|Galaxy A15 4g & 5g': 'cs1705738', 'Samsung|Galaxy A25 4g': 'cs1705738',
    'Samsung|Galaxy A25 5g': 'cs1705738', 'Samsung|Galaxy A35 5g': 'cs1705738',
    'Samsung|Galaxy A55 5g': 'cs1705738', 'Samsung|Galaxy M54 5g': 'cs1705738',
    'Samsung|Galaxy X Cover 7': 'cs1705738', 'Samsung|Galaxy A32 5g': 'cs1705738',
    'Google|Pixel 9a (6.3" Screen)': 'cs1705738', 'Samsung|Galaxy A06': 'cs1705738',
    'Samsung|Galaxy A16 5g': 'cs1705738', 'Samsung|Galaxy A36 5g': 'cs1705738',
    'Samsung|Galaxy A56 5g': 'cs1705738', 'Samsung|Galaxy A52 4g & 5g': 'cs1705738',
    'Samsung|Galaxy S21': 'cs1705738', 'Samsung|Galaxy S21 Ultra': 'cs1705738',
    'Samsung|Galaxy Note 20 Ultra 5g': 'cs1705738', 'Samsung|Galaxy A17 5g': 'cs1705738',
    'Samsung|Galaxy A37 5g': 'cs1705738', 'Samsung|Galaxy A57 5g': 'cs1705738',
    'Google|Pixel 5 5g': 'cs1866528', 'Google|Pixel 4a 5g': 'cs1866528', 'Apple|iPhone Xr': 'cs1866528',
    'Apple|iPhone 11': 'cs1866528', 'Samsung|Galaxy S20 FE': 'cs1866528', 'Samsung|Galaxy S9': 'cs1866528',
    'Apple|iPhone 11 Pro': 'cs1866528', 'Samsung|Galaxy Note 9': 'cs1866528',
    'Apple|iPhone 11 ProMax': 'cs1866528', 'Apple|iPhone SE2/SE3 (2020/2022 Version)': 'cs1866528',
    'Samsung|Galaxy S22 Plus': 'cs1866528', 'Samsung|Galaxy Note 10 Plus': 'cs1866528',
    'Samsung|Galaxy S22 Ultra': 'cs1866528', 'Samsung|Galaxy S23 Ultra': 'cs1866528',
    'Samsung|Galaxy S23 Plus': 'cs1866528', 'Samsung|Galaxy S23': 'cs1866528',
    'Samsung|Galaxy S24 Ultra': 'cs1866528', 'Apple|iPhone 14 Pro': 'cs1866528',
    'Apple|iPhone 16': 'cs1866528', 'Apple|iPhone 15 Plus': 'cs1866528',
    'Apple|iPhone XsMax': 'cs1866520', 'Apple|iPhone 12': 'cs1866520', 'Apple|iPhone 12 Pro': 'cs1866520',
    'Samsung|Galaxy S23 FE': 'cs1866520', 'Apple|iPhone 12 ProMax': 'cs1866520',
    'Samsung|Galaxy S10': 'cs1866520', 'Samsung|Galaxy Note 10': 'cs1866520',
    'Samsung|Galaxy S24': 'cs1866520', 'Samsung|Galaxy S10 Plus': 'cs1866520',
    'Samsung|Galaxy S20': 'cs1866520', 'Samsung|Galaxy S22': 'cs1866520',
    'Samsung|Galaxy S20 Plus': 'cs1866520', 'Samsung|Galaxy S20 Ultra': 'cs1866520',
    'Apple|iPhone 13 ProMax': 'cs1866520', 'Samsung|Galaxy Note 20 5g': 'cs1866520',
    'Apple|iPhone 13 Pro': 'cs1866520', 'Google|Pixel 4 4g': 'cs1866541',
    'Google|Pixel 4a 4g': 'cs1866541', 'Samsung|Galaxy A51 4g': 'cs1866541',
    'Google|Pixel 9 Pro XL (6.8" Screen)': 'cs1866541', 'Apple|iPhone 14 Plus': 'cs1866538',
    'Apple|iPhone 14 ProMax': 'cs1866538', 'Apple|iPhone 15 Pro': 'cs1866538',
    'Samsung|Galaxy Note 8': 'cs1866545', 'Google|Pixel 4 XL': 'cs1898539',
    'Samsung|Galaxy Z Flip 3 5g': 'cs1866957', 'Samsung|Galaxy Z Fold 3 5g': 'cs1866957',
    'Samsung|Galaxy Z Flip 4 5g': 'cs1866957', 'Samsung|Galaxy Z Fold 4 5g': 'cs1866957',
    'Samsung|Galaxy Z Fold 6 5g': 'cs1866957', 'Samsung|Galaxy Z Flip 7 5g': 'cs1866957',
    'Samsung|Galaxy Z Fold 7 5g': 'cs1866957', 'Samsung|Galaxy Z Flip 8 5g': 'cs1866957',
    'Samsung|Galaxy Z Fold 8 5g': 'cs1866957', 'Samsung|Galaxy Z Fold 8 Ultra 5g': 'cs1866957',
    'Google|Pixel 8 5g': 'cs2032826', 'Google|Pixel 8 Pro 5g': 'cs2032826',
    'Google|Pixel 8a 5g': 'cs2032826', 'Apple|iPhone X, Xs': 'cs1898672',
    'Samsung|Galaxy S21 Plus': 'cs1898672', 'Motorola|G Power (2021)': 'cs1898690',
    'Motorola|G Power (2022)': 'cs1898690', 'Motorola|Edge (2022)': 'cs1898690',
    'Google|Pixel 6 5g': 'cs1898690', 'Google|Pixel 7 5g': 'cs1898690',
    'Google|Pixel 7 Pro 5g': 'cs1898690', 'Samsung|Galaxy A42 5g': 'cs1898690',
    'Samsung|Galaxy A51 5g': 'cs1898690', 'Samsung|Galaxy A53 5g': 'cs1898690',
    'Samsung|Galaxy S21 FE': 'cs1898690', 'Samsung|Galaxy S10e': 'cs1898690',
    'Samsung|Galaxy A26 5g': 'cs1898690', 'Samsung|Galaxy Z Flip 5 5g': 'cs1998095',
    'Samsung|Galaxy Z Fold 5 5g': 'cs1998095', 'Samsung|Galaxy S24 FE': 'cs2210671',
    'Samsung|Galaxy S24 Plus': 'cs2210671', 'Samsung|Galaxy S25': 'cs2210671',
    'Samsung|Galaxy S25 Plus': 'cs2210671', 'Samsung|Galaxy S25 Ultra': 'cs2210671',
    'Apple|iPhone 15 ProMax': 'cs2273865', 'Apple|iPhone 16 Pro': 'cs2273865',
    'Apple|iPhone 16 Plus': 'cs2273865', 'Apple|iPhone 16 ProMax': 'cs2273865',
    'Apple|iPhone 13': 'cs2302322', 'Apple|iPhone 14': 'cs2302322', 'Apple|iPhone 15': 'cs2302322',
    'Apple|iPhone 16e /17e': 'cs2302322', 'Apple|iPhone 17 ProMax': 'cs2317490',
    'Apple|iPhone 17 Pro': 'cs2317490', 'Apple|iPhone 17': 'cs2317490',
    'Apple|iPhone 18 ProMax (New)': 'cs2317490', 'Apple|iPhone 18 Pro (New)': 'cs2317490',
    'Samsung|Galaxy S26 Ultra': 'cs2317490', 'Google|Pixel 9 & 9 Pro (6.3" Screen)': 'cs2318410',
    'Google|Pixel 10 & 10 Pro (6.3" Screen)': 'cs2318410',
    'Google|Pixel 10 Pro XL (6.8" Screen)': 'cs2318410',
    'Google|Pixel 11 Pro XL (6.8" Screen)': 'cs2318410',
    'Google|Pixel 11 & 11 Pro (6.3" Screen)': 'cs2318410', 'Apple|iPhone 17 Air': 'cs2318417',
    'Google|Pixel 10 Pro Fold': 'cs2323019', 'Samsung|Galaxy S26 Plus': 'cs2364183',
    'Samsung|Galaxy S26': 'cs2364183', 'Samsung|Galaxy S25 FE': 'cs2364183',
    'Google|Pixel 10a': 'cs2367879'
  };

  var DEFAULT_CASE_SET = 'cs2317490';

  // STEP 4 add-ons, all $9.99, on product 3857209000039 "Add-On Items:".
  var ADDONS = [
    ['ARMOR-GRIP\u2122 Raised Bed Liner Style Grip Overprint', 999, 45505923645748],
    ['TOPO-GRIP\u2122 Raised Topography Lines Grip Overprint', 999, 45238071656756],
    ['Tempered Glass Screen Protector', 999, 39634432655463],
    ['USB Charging Data Cable', 999, 39634432688231],
    ['2.4a USB Wall Charger', 999, 47412970455348]
  ];

  var BRANDS = ['Apple', 'Samsung', 'Google', 'Motorola'];

  var PROP_BRAND = 'Phone Brand';
  var PROP_MODEL = 'Phone Model';
  var PROP_CASE = 'Case Brand';
  var PROP_ADDONS = 'Add-Ons';

  var COOKIE = 'ego_phone';
  var COOKIE_DAYS = 180;
  var PHONE_EVENT = 'ego:phone-updated';
  var IO_WAIT_MS = 3000;

  /* ----------------------------------------------------------------- utils */

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function readPhone() {
    try {
      var raw = getCookie(COOKIE);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && o.brand && o.model) return o;
    } catch (e) { /* malformed cookie, ignore */ }
    return null;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function caseSetFor(brand, model) {
    var key = CASE_BY_MODEL[brand + '|' + model];
    return CASE_SETS[key] || CASE_SETS[DEFAULT_CASE_SET];
  }

  /* --------------------------------------------- Infinite Options detection */

  // IO renders its own inputs inside .bold_options / .bold_options_loaded. If a
  // firewall blocks options.shopapps.site the container simply stays empty.
  function ioLooksLoaded(form) {
    var containers = form.querySelectorAll('.bold_options, .bold_options_loaded');
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      if (c.querySelector('select, input, textarea, .bold_option, .bold_option_set')) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------- UI */

  function build(root) {
    var form = root.closest('form');
    if (!form) return;

    var productId = root.getAttribute('data-product-id');
    var variantIdInput = form.querySelector('[name="id"]');
    var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;

    var brandSel = root.querySelector('[data-ego-opt-brand]');
    var modelSel = root.querySelector('[data-ego-opt-model]');
    var caseWrap = root.querySelector('[data-ego-opt-cases]');
    var addonWrap = root.querySelector('[data-ego-opt-addons]');
    var totalEl = root.querySelector('[data-ego-opt-total]');
    var errEl = root.querySelector('[data-ego-opt-error]');

    BRANDS.forEach(function (b) {
      var o = document.createElement('option');
      o.value = b;
      o.textContent = b;
      brandSel.appendChild(o);
    });

    ADDONS.forEach(function (a, i) {
      var id = 'ego-addon-' + productId + '-' + i;
      var label = document.createElement('label');
      label.className = 'ego-opt__check';
      label.innerHTML =
        '<input type="checkbox" id="' + id + '" data-ego-addon="' + i + '">' +
        '<span>' + a[0] + ' <em>+' + money(a[1]) + '</em></span>';
      addonWrap.appendChild(label);
    });

    function fillModels(brand, selected) {
      modelSel.innerHTML = '<option value="">Select your model</option>';
      (MODELS[brand] || []).forEach(function (m) {
        var o = document.createElement('option');
        o.value = m;
        o.textContent = m;
        if (m === selected) o.selected = true;
        modelSel.appendChild(o);
      });
      modelSel.disabled = !brand;
    }

    function fillCases() {
      var brand = brandSel.value;
      var model = modelSel.value;
      caseWrap.innerHTML = '';
      if (!brand || !model) {
        caseWrap.innerHTML = '<p class="ego-opt__hint">Pick your phone model first.</p>';
        return;
      }
      caseSetFor(brand, model).forEach(function (c, i) {
        var id = 'ego-case-' + productId + '-' + i;
        var label = document.createElement('label');
        label.className = 'ego-opt__check';
        label.innerHTML =
          '<input type="radio" name="ego-case-' + productId + '" id="' + id + '"' +
          ' data-ego-case="' + i + '"' + (i === 0 ? ' checked' : '') + '>' +
          '<span>' + c[0] + ' <em>' + (c[1] ? '+' + money(c[1]) : 'Included') + '</em></span>';
        caseWrap.appendChild(label);
      });
    }

    function selectedCase() {
      var brand = brandSel.value;
      var model = modelSel.value;
      if (!brand || !model) return null;
      var set = caseSetFor(brand, model);
      var checked = caseWrap.querySelector('[data-ego-case]:checked');
      if (!checked) return null;
      return set[parseInt(checked.getAttribute('data-ego-case'), 10)];
    }

    function selectedAddons() {
      var out = [];
      addonWrap.querySelectorAll('[data-ego-addon]:checked').forEach(function (el) {
        out.push(ADDONS[parseInt(el.getAttribute('data-ego-addon'), 10)]);
      });
      return out;
    }

    function refreshTotal() {
      var total = basePrice;
      var c = selectedCase();
      if (c) total += c[1];
      selectedAddons().forEach(function (a) { total += a[1]; });
      if (totalEl) totalEl.textContent = money(total);
    }

    function prefillFromCookie() {
      var phone = readPhone();
      if (!phone) {
        fillModels('', '');
        fillCases();
        refreshTotal();
        return;
      }
      brandSel.value = phone.brand;
      fillModels(phone.brand, phone.model);
      modelSel.value = phone.model;
      fillCases();
      refreshTotal();
    }

    brandSel.addEventListener('change', function () {
      fillModels(brandSel.value, '');
      fillCases();
      refreshTotal();
    });

    modelSel.addEventListener('change', function () {
      if (brandSel.value && modelSel.value) {
        setCookie(COOKIE, JSON.stringify({ brand: brandSel.value, model: modelSel.value }), COOKIE_DAYS);
        document.dispatchEvent(new CustomEvent(PHONE_EVENT));
      }
      fillCases();
      refreshTotal();
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-ego-case], [data-ego-addon]')) refreshTotal();
    });

    document.addEventListener(PHONE_EVENT, function () {
      // Badge and fallback share the ego_phone cookie; keep them in sync.
      var phone = readPhone();
      if (!phone) return;
      if (brandSel.value === phone.brand && modelSel.value === phone.model) return;
      brandSel.value = phone.brand;
      fillModels(phone.brand, phone.model);
      fillCases();
      refreshTotal();
    });

    /* --------------------------------------------------------- add to cart */

    function addToCart(e) {
      e.preventDefault();
      e.stopPropagation();

      var brand = brandSel.value;
      var model = modelSel.value;
      var caseChoice = selectedCase();

      if (!brand || !model || !caseChoice) {
        errEl.textContent = 'Please choose your phone brand, model and case.';
        errEl.hidden = false;
        return;
      }
      errEl.hidden = true;

      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var addons = selectedAddons();
      var bundleId = 'ego-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

      var props = {};
      props[PROP_BRAND] = brand;
      props[PROP_MODEL] = model;
      props[PROP_CASE] = caseChoice[0];
      if (addons.length) {
        props[PROP_ADDONS] = addons.map(function (a) { return a[0]; }).join(', ');
      }
      props._ego_bundle = bundleId;
      props._ego_source = 'theme-fallback';

      var items = [{
        id: parseInt(variantIdInput.value, 10),
        quantity: qty,
        properties: props
      }];

      // Upgrade fees and add-ons are real catalog variants, so the customer is
      // charged the correct amount without Shopify Functions or a draft order.
      if (caseChoice[1] > 0) {
        items.push({
          id: caseChoice[2],
          quantity: qty,
          properties: { _ego_bundle: bundleId, _ego_for: model }
        });
      }
      addons.forEach(function (a) {
        items.push({
          id: a[2],
          quantity: qty,
          properties: { _ego_bundle: bundleId, _ego_for: model }
        });
      });

      var btn = form.querySelector('[name="add"]');
      if (btn) btn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Add to cart failed'); });
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function (err) {
        errEl.textContent = err.message || 'Sorry, we could not add this to your cart.';
        errEl.hidden = false;
        if (btn) btn.removeAttribute('disabled');
      });
    }

    function activate() {
      root.hidden = false;
      form.setAttribute('data-ego-fallback-active', 'true');
      // Take over submit so the upgrade/add-on lines go in with the case.
      form.addEventListener('submit', addToCart, true);
      var btn = form.querySelector('[name="add"]');
      if (btn) btn.addEventListener('click', addToCart, true);
      prefillFromCookie();
    }

    prefillFromCookie();

    window.setTimeout(function () {
      var force = /[?&]ego_force_theme_options=1/.test(location.search);
      if (!force && ioLooksLoaded(form)) return; // Infinite Options is fine, stay hidden.
      activate();
    }, IO_WAIT_MS);
  }

  function init() {
    document.querySelectorAll('[data-ego-options], [data-ego-theme-options]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
